import React, { useState } from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'
import MyRadio from '../../../components/forms/radio'

const EditFormStatus = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [formValue, setFormValue] = useState({
    form_status: props.data.form_status
  })
  
  const handleOk = () => {
    axios.post('/p/assessment/config/edit', { 
      merchant_oid: merchantOid, 
      form_status: formValue.form_status
    })
      .then(function (response) {
        if (response.errcode === 0) {
          props.isCancel()
          props.getAssessmentConfig()
          message.success('修改成功！')
        } else {
          message.error(response.msg)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  return (
    <Modal 
      title='用户信息表单收集状态'
      destroyOnClose={true}
      width='500px'
      open={props.isOpen}
      onOk={handleOk}
      onCancel={props.isCancel}
      cancelText="取消"
      okText="保存">

      <MyRadio
        id='form_status'
        label='选择状态'
        options={[
          {
            label: '必填',
            value: 1,
          },
          {
            label: '非必填',
            value: 2,
          },
          {
            label: '不填',
            value: 3,
          }
        ]}
        defaultValue={1}
        value={formValue.form_status}
        onChange={setFormValue}
      />
    </Modal>
  )
}

export default EditFormStatus
